import styled from 'styled-components'

export const CustomFormItem = styled.div`
	.ant-form-item .ant-form-item-label > label::after {
		display: none;
	}

	.ant-form-item-label
		> label.ant-form-item-required:not(.ant-form-item-required-mark-optional)
		> p::after {
		content: '必須';
		background-color: #ff4d4f;
		visibility: visible !important;
		white-space: nowrap !important;
		display: inline-block;
		margin-left: 6px;
		color: white;
		font-size: 12px;
		padding: 2px 4px;
		border-radius: 4px;
	}
`

export const StyledUploadButton = styled.div`
	.ant-upload-list-item-thumbnail {
		border-radius: 8px;
	}
	.ant-upload-wrapper.ant-upload-picture-card-wrapper
		.ant-upload-list.ant-upload-list-picture-card
		.ant-upload-list-item-actions {
	}

	.dash-style {
		border: 2px dashed black;
		border-image: repeating-linear-gradient(
				90deg,
				black 0,
				black 10px,
				transparent 10px,
				transparent 20px
			)
			10;
	}
	.ant-upload-wrapper.ant-upload-picture-card-wrapper .ant-upload.ant-upload-select {
		background-image:
			repeating-linear-gradient(
				-6deg,
				rgba(0, 0, 0, 0.15),
				rgba(0, 0, 0, 0.15) 11px,
				transparent 11px,
				transparent 20px,
				rgba(0, 0, 0, 0.15) 20px
			),
			repeating-linear-gradient(
				84deg,
				rgba(0, 0, 0, 0.15),
				rgba(0, 0, 0, 0.15) 11px,
				transparent 11px,
				transparent 20px,
				rgba(0, 0, 0, 0.15) 20px
			),
			repeating-linear-gradient(
				174deg,
				rgba(0, 0, 0, 0.15),
				rgba(0, 0, 0, 0.15) 11px,
				transparent 11px,
				transparent 20px,
				rgba(0, 0, 0, 0.15) 20px
			),
			repeating-linear-gradient(
				264deg,
				rgba(0, 0, 0, 0.15),
				rgba(0, 0, 0, 0.15) 11px,
				transparent 11px,
				transparent 20px,
				rgba(0, 0, 0, 0.15) 20px
			);

		background-size:
			1px 100%,
			100% 1px,
			1px 100%,
			100% 1px;
		background-position:
			0 0,
			0 0,
			100% 0,
			0 100%;
		background-repeat: no-repeat;
		border: none;
		background-color: transparent;
	}
	.ant-upload-wrapper.ant-upload-picture-card-wrapper
		.ant-upload-list.ant-upload-list-picture-card
		.ant-upload-list-item::before {
		width: 100%;
		height: 100%;
		border-radius: 8px;
	}
	.ant-upload-wrapper .ant-upload-list.ant-upload-list-picture-card .ant-upload-list-item {
		padding: 0;
	}
`
